<template>
  <div class="layout__padding-clear layout__width-60">
    <div class="text__align-center text__colour-white ">
      <div class="layout__padding-clear layout__width-70 layout__padding-40px-0 layout__border__bottom-light-teal-1px">
        <h2 class="text__colour-teal">
          My Basket
        </h2>
        <div class="layout__padding-20-0 text__size-18 text__colour-grey">
          View, amend and finalise orders which are currently incomplete
        </div>
      </div>
    </div>

    <div class="layout__padding-20-0">
      <div class="layout__padding-clear layout__border__bottom">
        <h3
          class="text__colour-teal layout__width-50 layout__position-left layout__padding-20-0 layout__border__bottom"
        >
          Photofixr
        </h3>
        <h3
          class="text__colour-teal layout__width-50 layout__position-left text__align-right layout__border__bottom layout__padding-20-0"
        >
          {{ getPhotofixrTotal.photofixr.total }} order
          {{ typeof photofixrJobs.orders === 'undefined' || photofixrJobs.orders.length > 1 ? 'items' : 'item' }}
        </h3>
      </div>
      <div
        v-if="photofixrJobId === null"
        class="layout__padding-clear layout__border__bottom"
      >
        <div class="layout__margin-20-0 text__align-center">
          <p class="text__align-center layout__padding-10px-0">
            No Photofixr items in the basket. Get started now
          </p>
          <el-button
            class="button-red button__base layout__width-300px layout__margin-20-0"
            @click="startPhotofixr()"
          >
            Photofixr
          </el-button>
        </div>
      </div>

      <!--<div v-if="photofixrJobId !== null && photofixrJobs.orders !== 'undefined'" class="layout__padding-clear layout__border__bottom">-->
      <!--<div class="layout__margin-20-0 text__align-center">-->
      <!--<p class="text__align-center layout__padding-10px-0">No Photofixr items in the basket. Get started now</p>-->
      <!--<el-button-->
      <!--class="button-red button__base layout__width-300px layout__margin-20-0"-->
      <!--@click="startPhotofixr()">Photofixr-->
      <!--</el-button>-->
      <!--</div>-->
      <!--</div>-->

      <div v-if="photofixrJobId !== null && typeof photofixrJobs.orders !== 'undefined'">
        <div
          v-if="photofixrJobId !== null && typeof photofixrJobs.orders !== 'undefined' && photofixrJobs.orders.length !== 0"
        >
          <p
            class="text__align-right layout__cursor-pointer"
            @click="wipePhotofixrDialog = true"
          >
            remove all
          </p>
          <div>
            <div class="layout__height-100 layout__position-center">
              <div class="">
                <div class="component__forms-3">
                  <div class="component__subtitle text__colour-teal">Uploaded Photos</div>
                </div>
                <div class="component__forms-2">
                  <div class="component__subtitle text__colour-teal">Photo Enhancements</div>
                </div>
              </div>
            </div>

            <div class="">
              <table
                v-for="order in photofixrJobs.orders"
                :key="order.id"
              >
                <tr>
                  <td class="layout__border__none">
                    <div class="">
                      <div class="component__forms-3">
                        <div class="layout__width-200px">
                          <!--<div>-->
                          <img
                            class="component__thumbnails-leading"
                            :src="order.leadImageUrlThumb"
                          />
                          <!--</div>-->
                        </div>
                      </div>
                      <div class="component__forms-2 text__align-center layout__position-left">
                        <div
                          class=""
                          v-for="task in order.taskItems"
                          :key="task.id"
                        >
                          <span
                            v-show="task.taskType === 'Brighten Image'"
                            class="layout__position-left"
                          >
                            <i class="text__size-45 icon-brighten text__colour-teal"></i>
                          </span>
                          <span
                            v-show="task.taskType === 'Add Blue Sky'"
                            class="layout__position-left"
                          >
                            <i class="text__size-45 icon-sky text__colour-teal"></i>
                          </span>
                          <span
                            v-show="task.taskType === 'Increase Vibrancy'"
                            class="layout__position-left"
                          >
                            <i class="text__size-45 icon-vibrance text__colour-teal"></i>
                          </span>
                          <span
                            v-show="task.taskType === 'Correct Distortion'"
                            class="layout__position-left"
                          >
                            <i class="text__size-45 icon-distortion text__colour-teal"></i>
                          </span>
                          <span
                            v-show="task.taskType === 'Add Grass'"
                            class="layout__position-left"
                          >
                            <i class="text__size-45 icon-add-grass text__colour-red"></i>
                          </span>
                          <span
                            v-show="task.taskType === 'Remove Object'"
                            class="layout__position-left"
                          >
                            <i class="text__size-45 icon-remove text__colour-red"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </table>
            </div>

            <div class="text__align-right">
              <h3 class="text__colour-teal text__align-right layout__border__bottom__top">
                Subtotal: {{ returnFormattedCurrency(this.photofixrJobs.netTotalBeforeDiscount) }}
              </h3>
            </div>
          </div>

          <div class="layout__padding-clear">
            <el-button
              class="button-teal layout__position-left button__base layout__width-200px layout__margin-20-0"
              @click="amendPhotofixr()"
            >
              Amend Order
            </el-button>
            <el-button
              class="button-red layout__position-right button__base layout__width-200px layout__margin-20-0"
              @click="checkoutPhotofixr()"
            >
              Photofixr Checkout
            </el-button>
          </div>
        </div>
      </div>

    </div>
    <div class="layout__margin-20-0">
      <div class="layout__padding-clear layout__border__bottom">
        <h3
          class="text__colour-teal layout__width-50 layout__position-left layout__border__bottom layout__padding-20-0"
        >
          Instant Print
        </h3>
        <h3
          v-if="instantPrintJobs"
          class="text__colour-teal layout__width-50 layout__position-left text__align-right layout__border__bottom layout__padding-20-0"
        >
          {{ instantPrintJobs.length }} order {{ instantPrintJobs.length === 1 ? 'item' : 'items' }}
        </h3>
        <h3
          v-else
          class="text__colour-teal layout__width-50 layout__position-left text__align-right layout__border__bottom layout__padding-20-0"
        >
          0 order items
        </h3>
      </div>

      <div
        v-if="!(instantPrintJobs && instantPrintJobs.length)"
        class="layout__padding-clear layout__border__bottom"
      >
        <div class="layout__margin-20-0 text__align-center">
          <p class="text__align-center layout__padding-10px-0">
            No Instant Print items in the basket. Get started now
          </p>
          <el-button
            class="button-red button__base layout__width-300px layout__margin-20-0"
            @click="startInstantPrint()"
          >
            Instant Print
          </el-button>
        </div>
      </div>

      <div v-if="instantPrintJobs && instantPrintJobs.length">
        <p
          class="text__align-right layout__cursor-pointer"
          @click="wipeInstantPrintDialog = true"
        >
          remove all
        </p>

        <instant-print-job
          v-for="instantPrintJob in instantPrintJobs"
          :instant-print-job="instantPrintJob"
          :key="instantPrintJob.id"
          @removeInstantPrintItem="onRemoveInstantPrintItem"
        />

        <div class="text__align-right">
          <h3 class="text__colour-teal text__align-right layout__border__bottom__top">
            Subtotal: {{ instantPrintJobsTotalPrice }}
          </h3>
        </div>
        <div class="layout__padding-clear">
          <el-button
            class="button-red layout__position-right button__base layout__width-200px layout__margin-20-0"
            @click="checkoutInstantPrint()"
          >
            Instant Print Checkout
          </el-button>
        </div>
      </div>
      <!--<div class="layout__padding-clear text__align-right">-->

      <!--<h3 class="text__colour-teal text__align-right layout__border__bottom layout__padding-20-0">-->
      <!--VAT: {{returnFormattedCurrency(this.orderVat)}}-->
      <!--</h3>-->
      <!--<h3 class="text__colour-teal text__align-right layout__border__bottom layout__padding-20-0">-->
      <!--Total: {{this.photofixrJobs.grossTotalPrice}} + {{this.instantPrintJob.grossTotalPrice}}-->
      <!--</h3>-->

      <!--</div>-->
    </div>
    <div class="layout__padding-20-0">
      <div class="layout__padding-clear layout__border__bottom">
        <h3
          class="text__colour-teal layout__width-50 layout__position-left layout__border__bottom layout__padding-20-0"
        >
          Directmailr
        </h3>
        <h3
          class="text__colour-teal layout__width-50 layout__position-left text__align-right layout__border__bottom layout__padding-20-0"
        >
          {{ getPhotofixrTotal.directmailr.total }} order item<span v-if="directmailrOrder == null">s</span>
        </h3>
      </div>

      <div
        v-if="directmailrOrderId === null"
        class="layout__padding-clear layout__border__bottom"
      >
        <div class="layout__margin-20-0 text__align-center">
          <p class="text__align-center layout__padding-10px-0">
            No Directmailr items in the basket. Get started now
          </p>
          <el-button
            class="button-red button__base layout__width-300px layout__margin-20-0"
            @click="startDirectmailr()"
          >
            Directmailr
          </el-button>
        </div>
      </div>

      <div v-if="directmailrOrderId !== null">
        <p
          class="text__align-right layout__cursor-pointer"
          @click="wipeDirectmailrDialog = true"
        >remove
          all
        </p>

        <div class="layout__padding-clear text__align-left">
          <div class="">
            <div class="layout__height-100 layout__position-center">
              <div class="">
                <div class="layout__height-100 layout__position-center layout__padding__bottom-20">
                  <div class="">
                    <div class="component__forms-3">
                      <div class="component__subtitle text__colour-teal">Artwork Preview</div>
                    </div>
                    <div class="component__forms-2">
                      <div class="component__subtitle text__colour-teal">Directmailr Selections</div>
                    </div>
                  </div>
                </div>

                <div class="">
                  <div class="component__forms-3">
                    <div class="layout__width-200px">
                      <img
                        class="component__thumbnails-leading"
                        :src="directmailrOrder.imageFileName"
                      />
                      &nbsp;
                    </div>
                  </div>

                  <div class="component__forms-2 text__align-center layout__position-left">
                    <div class="text__line-height-2 layout__padding-clear">
                      <span v-show="directmailrOrder.dataProvider !== null">
                        <p class="component__subtitle component__columns-2">Data Provider</p>
                        <p
                          class="component__columns-2"
                        >{{ this.directmailrOrder.dataProvider }}
                        </p>
                      </span>

                      <span v-show="show_quantity">
                        <p class="component__subtitle component__columns-2">Quantity</p>
                        <p class="component__columns-2">{{ directmailr_quantity }}</p>
                      </span>

                      <span v-show="show_name">
                        <p class="component__subtitle component__columns-2">Template Name</p>
                        <p class="component__columns-2">{{ directmailr_name }}</p>
                      </span>

                      <span
                        v-show="directmailrOrder.productPriceCode !== null && directmailrOrder.productPriceCode !== ''"
                      >
                        <p class="component__subtitle component__columns-2">Product Code</p>
                        <p
                          class="component__columns-2"
                        >{{ this.directmailrOrder.productPriceCode }}
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="text__align-right">
          <h3 class="text__colour-teal text__align-right layout__border__bottom__top">
            Subtotal: {{ directmailr_gross_price }}
          </h3>
        </div>

        <div class="layout__padding-clear">
          <el-button
            class="button-teal layout__position-left button__base layout__width-200px layout__margin-20-0"
            @click="amendDirectmailr()"
          >Amend Order
          </el-button>
          <el-button
            class="button-red layout__position-right button__base layout__width-200px layout__margin-20-0"
            :disabled="directmailr_disable_checkout"
            @click="checkoutDirectmailr()"
          >Directmailr Checkout
          </el-button>
        </div>
      </div>
    </div>

    <el-dialog
      :visible.sync="wipePhotofixrDialog"
      width="500px"
    >
      <div class="layout__position-center text__align-center">
        <h3 class="text__colour-teal layout__padding-20-0">Are you sure you want to remove
          <br>
          ALL Photofixr
          items?
        </h3>
        <p class="layout__margin__bottom-6px">This action can't be undone</p>
        <div class="layout__padding-clear">
          <div class="layout__padding-20-0">
            <el-button
              class="button-teal button__base layout__margin__right-20px layout__width-150px"
              @click="removeAllPhotofixr()"
            >Yes
            </el-button>
            <el-button
              class="button-red button__base layout__width-150px"
              @click="wipePhotofixrDialog = false"
            >No
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="wipeInstantPrintDialog"
      width="500px"
    >
      <div class="layout__position-center text__align-center">
        <h3 class="text__colour-teal layout__padding-20-0">Are you sure you want to remove
          <br>
          the Instant Print
          order?
        </h3>
        <p class="layout__margin__bottom-6px">This action can't be undone</p>
        <div class="layout__padding-clear">
          <div class="layout__padding-20-0">
            <el-button
              class="button-teal button__base layout__margin__right-20px layout__width-150px"
              @click="removeAllInstantPrint()"
            >
              Yes
            </el-button>
            <el-button
              class="button-red button__base layout__width-150px"
              @click="wipeInstantPrintDialog = false"
            >
              No
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="removeInstantPrintItemDialog"
      width="500px"
    >
      <div class="layout__position-center text__align-center">
        <h3 class="text__colour-teal layout__padding-20-0">Are you sure you want to remove
          <br>
          the Instant Print
          item?
        </h3>
        <p class="layout__margin__bottom-6px">This action can't be undone</p>
        <div class="layout__padding-clear">
          <div class="layout__padding-20-0">
            <el-button
              class="button-teal button__base layout__margin__right-20px layout__width-150px"
              @click="removeInstantPrintOrderItem()"
            >Yes
            </el-button>
            <el-button
              class="button-red button__base layout__width-150px"
              @click="removeInstantPrintItemDialog = false"
            >
              No
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="incompletePhotofixr"
      width="500px"
    >
      <div class="layout__position-center text__align-center">
        <h3 class="text__colour-teal layout__padding-20-0">Please complete your Photofixr order before
          <br>
          proceeding
          to the checkout
        </h3>
        <div class="layout__padding-clear">
          <div class="layout__padding-20-0 text__align-center">
            <el-button
              class="button-red button__base layout__width-150px"
              @click="amendPhotofixr()"
            >Complete Order
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="incompleteInstantPrint"
      width="500px"
    >
      <div class="layout__position-center text__align-center">
        <h3 class="text__colour-teal layout__padding-20-0">Please complete your Instant Print
          <br>
          order before
          proceeding to the checkout
        </h3>
        <div class="layout__padding-clear">
          <div class="layout__padding-20-0 text__align-center">
            <el-button
              class="button-red button__base layout__width-150px"
              @click="amendInstantPrint()"
            >Complete Order
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="wipeDirectmailrDialog"
      width="500px"
    >
      <div class="layout__position-center text__align-center">
        <h3 class="text__colour-teal layout__padding-20-0">Are you sure you want to remove
          <br>
          the Directmailr
          item?
        </h3>
        <p class="layout__margin__bottom-6px">This action can't be undone</p>
        <div class="layout__padding-clear">
          <div class="layout__padding-20-0">
            <el-button
              class="button-teal button__base layout__margin__right-20px layout__width-150px"
              @click="removeAllDirectmailr()"
            >Yes
            </el-button>
            <el-button
              class="button-red button__base layout__width-150px"
              @click="wipeDirectmailrDialog = false"
            >No
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>


<script>
import { mapGetters } from 'vuex';
import Router from '../../router';
import { axios } from '@/mixins/Axios.js';
import { dataFormatter } from '@/mixins/DataFormatter.js';
import Axios from 'axios';
import InstantPrintJob from '../partials/InstantPrintJob';

export default {
  name: 'basketPage',

  components: {
    InstantPrintJob,
  },

  mixins: [
    axios,
    dataFormatter,
  ],

  data() {
    return {
      photofixrJobId: '',
      rules: {},
      photofixrJobs: {},
      wipePhotofixrDialog: false,
      disablePhotofixrCheckout: false,
      incompletePhotofixr: false,
      incompleteInstantPrint: false,
      instantPrintJob: {},
      wipeInstantPrintDialog: false,
      orderTotal: '',
      orderVat: '',
      directmailrOrderId: '',
      directmailrOrder: {},
      directmailrImageUrl: null,
      wipeDirectmailrDialog: false,
      instantPrintJobs: [],
      incompleteJob: null,
      removeInstantPrintItemDialog: false,
      removeInstantPrintItem: null,
    };
  },

  computed: {
    ...mapGetters(
      ['getPhotofixrTotal', 'getOrderTotal', 'getInstantPrintTotal'],
    ),

    directmailr_gross_price() {
      let grossPrice = this.returnFormattedCurrency(0);

      if (this.directmailrOrder !== undefined) {
        if (this.directmailrOrder.grossTotalPrice != null) {
          grossPrice = this.returnFormattedCurrency(this.directmailrOrder.grossTotalPrice);
        }
      }

      return grossPrice;
    },

    directmailr_quantity() {
      let quantity = 0;

      if (this.directmailrOrder.printJobSpec !== undefined) {
        if (this.directmailrOrder.printJobSpec.quantity != null) {
          quantity = this.directmailrOrder.printJobSpec.quantity;
        }
      }

      return quantity;
    },

    directmailr_name() {
      let name = '';

      if (this.directmailrOrder.printJobSpec !== undefined) {
        if (this.directmailrOrder.printJobSpec.name != null) {
          name = this.directmailrOrder.printJobSpec.name;
        }
      }

      return name;
    },

    directmailr_disable_checkout() {
      let disabled = false;

      if (this.directmailrOrder !== undefined) {
        //if (this.directmailrOrder.grossTotalPrice === null) {
        if (this.directmailrOrder.productPriceCode === null || this.directmailrOrder.productPriceCode === '') {
          disabled = true;
        }
      }

      return disabled;
    },

    show_quantity() {
      let showQuantity = false;

      if (this.directmailrOrder.printJobSpec !== undefined) {
        if (this.directmailrOrder.printJobSpec.quantity !== 0) {
          showQuantity = true;
        }
      }

      return showQuantity;
    },

    show_name() {
      let showName = false;

      if (this.directmailrOrder.printJobSpec !== undefined) {
        if (this.directmailrOrder.printJobSpec.name !== null) {
          showName = true;
        }
      }

      return showName;
    },

    instantPrintJobsTotalPrice() {
      return this.returnFormattedCurrency(
        this.instantPrintJobs.reduce((acc, curr) => acc + Number(curr.netTotalPrice), 0),
      );
    },
  },

  created() {
    //todo get Photofixr order
    // if (window.sessionStorage.getItem('_jobId') !== null) {
    this.photofixrJobId = window.sessionStorage.getItem('_jobId');

    console.log(this.photofixrJobId);

    if (this.photofixrJobId !== null) {
      console.log('getting job');

      const getJobUrl = `${process.env.VUE_APP_PHOTOFIXRAPIHOST}/api/v1/photofixr/jobs/` + this.photofixrJobId;
      Axios.get(getJobUrl, this.returnHeaderUsingToken())
        .then(response => {
          this.photofixrJobs = response.data;

          for (let i = 0; i < this.photofixrJobs.orders.length; i++) {
            if (this.photofixrJobs.orders[i].taskItems.length === 0) {
              this.disablePhotofixrCheckout = true;
            }
          }
          //
          // console.log(this.photofixrJobs.vatTotalPrice)
          // console.log(this.instantPrintJob.vatTotalPrice)
          // this.orderVat = +this.photofixrJobs.vatTotalPrice + +this.instantPrintJob.vatTotalPrice
          // Math.ceil(this.orderVat)

        });
    }

    //todo get instant print order
    // if (window.sessionStorage.getItem('_printJob') !== null) {
    this.instantPrintJob = JSON.parse(window.sessionStorage.getItem('_printJob'));
    // }

    this.instantPrintJobs = JSON.parse(window.sessionStorage.getItem('_printJobs'));

    // console.log(this.photofixrJobs.vatTotalPrice)
    // this.orderVat = +this.photofixrJobs.vatTotalPrice + +this.instantPrintJob.vatTotalPrice

    this.directmailrOrderId = window.sessionStorage.getItem('_dm_order_id');

    console.log(this.directmailrOrderId);

    if (this.directmailrOrderId !== null) {
      console.log('getting dm order');

      const getJobUrl = `${process.env.VUE_APP_TKGATEWAY}/api/DataOrder/` + this.directmailrOrderId;
      Axios.get(getJobUrl, this.returnHeaderUsingToken())
        .then(response => {
          console.log(response.data);
          this.directmailrOrder = response.data[0];

          Axios({
            method: 'get',
            url: this.directmailrOrder.imageUrl,
            responseType: 'blob', //Force to receive data in a Blob Format
          })
            .then(response => {
              //Create a Blob from the PDF Stream
              const file = new Blob(
                [response.data],
                { type: 'application/pdf' });
              //Build a URL from the file
              //const fileURL = URL.createObjectURL(file);
//console.log('fileURL=' + fileURL);
              this.directmailrImageUrl = URL.createObjectURL(file);
              //Open the URL on new Window
              //window.open(fileURL);
            })
            .catch(error => {
              console.log(error);
            });
        });
    } else {
      this.directmailrOrder = null;
    }
  },

  methods: {
    startPhotofixr() {
      Router.push({
        name: '/photofixr',
      });
    },

    checkoutPhotofixr() {
      if (this.disablePhotofixrCheckout) {
        this.incompletePhotofixr = true;
      } else {
        if (this.returnCookie('_token') === null) {
          window.sessionStorage.setItem('_routerFrom', '/photofixr/checkout');
          document.getElementById('openLoginClosable').click();
        } else {
          Router.push({
            name: '/photofixr/checkout',
          });
        }
      }
    },

    amendPhotofixr() {
      this.incompletePhotofixr = false;
      Router.push({
        name: '/photofixr/selections',
      });
    },

    removeAllPhotofixr() {
      const removeCurrentOrder = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Session/RemoveActiveOrder?userId=` + window.sessionStorage.getItem('_userId') + '&customerRef=' + JSON.parse(window.sessionStorage.getItem('_customer')).ref + '&orderSource=PHOTOFIXR&orderSourceId=' + window.sessionStorage.getItem('_jobId');
      console.log(removeCurrentOrder);
      Axios.delete(removeCurrentOrder, this.returnHeaderUsingToken())
        .then(response => {
          console.log(response);
          this.photofixrJobId = null;
          this.photofixrJobs = {};
          this.wipePhotofixrDialog = false;
          window.sessionStorage.removeItem('_fixes');
          window.sessionStorage.removeItem('_jobId');
          window.sessionStorage.removeItem('_errors');

          const basketTotals = {
            photofixr: 0,
          };
          this.$store.dispatch('incrementPhotofixrTotal', basketTotals);
        });
    },

    startInstantPrint() {
      Router.push({
        name: '/instant-print',
      });
    },

    amendInstantPrint() {
      this.incompleteInstantPrint = false;
      if (this.incompleteJob.printJobSpec.fCode !== null) {
        Router.push({
          name: '/instant-print/print-selections',
          params: {
            printJob: this.incompleteJob,
            searchParams: this.searchParams,
            preferences: this.incompleteJob.printJobSpec,
          },
        });
      } else {
        Router.push({
          name: '/instant-print/artwork-preview',
          params: {
            printJob: this.incompleteJob,
            searchParams: this.searchParams,
          },
        });
      }
    },

    checkoutInstantPrint() {
      this.incompleteJob = this.instantPrintJobs.find(printJob => {
        return printJob.printJobSpec.stockWeight === null || printJob.printJobSpec.stockType === null || printJob.printJobSpec.lamination === null || printJob.printJobSpec.quantity === 0;
      });

      if (this.incompleteJob) {
        this.incompleteInstantPrint = true;
      } else {
        Router.push({
          name: '/instant-print/checkout',
          params: {
            searchParams: this.searchParams,
          },
        });
      }
    },

    removeAllInstantPrint() {
      this.instantPrintJobs.forEach(instantPrintJob => {
        this.removeInstantPrintOrderItem(instantPrintJob);
      });
    },

    onRemoveInstantPrintItem(jobItem) {
      this.removeInstantPrintItemDialog = true;
      this.removeInstantPrintItem = jobItem;
    },

    removeInstantPrintOrderItem(jobItem = null) {
      const job = jobItem ? jobItem : this.removeInstantPrintItem;

      const removeCurrentOrder = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Session/RemoveActiveOrder?userId=`
        + window.sessionStorage.getItem('_userId')
        + '&customerRef='
        + JSON.parse(window.sessionStorage.getItem('_customer')).ref
        + '&orderSource=PDFUPLOAD&orderSourceId=' + job.id;

      console.log(removeCurrentOrder);

      Axios.delete(removeCurrentOrder, this.returnHeaderUsingToken())
        .then(response => {
          console.log(response);
          this.instantPrintJob = null;
          this.wipeInstantPrintDialog = false;
          this.removeInstantPrintItemDialog = false;
          window.sessionStorage.removeItem('_printJob');

          this.instantPrintJobs = this.instantPrintJobs.filter(instantPrintJob => instantPrintJob.id !== job.id);

          window.sessionStorage.setItem('_printJobs', JSON.stringify(this.instantPrintJobs));

          const basketTotals = {
            instantPrint: this.instantPrintJobs.length,
          };

          this.$store.dispatch('incrementPhotofixrTotal', basketTotals);
        });
    },

    startDirectmailr() {
      Router.push({
        name: '/directmailr',
      });
    },

    checkoutDirectmailr() {
      Router.push({
        path: '/directmailr/place-order',
        query: { page: 'Checkout', order_id: this.directmailrOrderId },
      });
    },

    amendDirectmailr() {
      console.log(this.directmailrOrder);

      if (this.directmailrOrder.dataUrl === null) {
        Router.push({
          path: '/directmailr/place-order',
          query: { page: this.directmailrOrder.dataProvider, order_id: this.directmailrOrderId },
        });
      } else {
        if (this.directmailrOrder.printJobSpec.quantity === 0) {
          Router.push({
            path: '/directmailr/place-order',
            query: { page: 'PreviewData', order_id: this.directmailrOrderId },
          });
        } else {
          if (this.directmailrOrder.templateId === null) {
            Router.push({
              path: '/directmailr/place-order',
              query: { page: 'SelectTemplate', order_id: this.directmailrOrderId },
            });
          } else {
            if (this.directmailrOrder.imageUrl === null) {
              Router.push({
                path: '/directmailr/place-order',
                query: { page: 'PersonaliseDesign', order_id: this.directmailrOrderId },
              });
            } else {
              if (this.directmailrOrder.productPriceCode === null || this.directmailrOrder.productPriceCode === '') {
                Router.push({
                  path: '/directmailr/place-order',
                  query: { page: 'PrintOptions', order_id: this.directmailrOrderId },
                });
              } else {
                Router.push({
                  path: '/directmailr/place-order',
                  query: { page: 'Checkout', order_id: this.directmailrOrderId },
                });
              }
            }
          }
        }
      }
    },

    removeAllDirectmailr() {
      this.directmailrOrderId = null;
      this.wipeDirectmailrDialog = false;
      window.sessionStorage.removeItem('_dm_order_id');

      const basketTotals = {
        directmailr: 0,
      };

      this.$store.dispatch('incrementPhotofixrTotal', basketTotals);
    },
  },
};
</script>
